import styled, { css, keyframes } from 'styled-components';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import { RouterLink } from '@redux-first-router-link';
import { Button } from '@simplywallst/ui-core';
import type { TransitionStatus } from 'react-transition-group/Transition';

const menuEntering = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
`;

const menuExiting = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
`;

interface ContainerProps {
  status?: TransitionStatus;
}
export const Container = styled('div')<ContainerProps>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  background-color: white;
  width: 250px;
  padding: 86px 18px;
  animation: ${(props) => {
      switch (props.status) {
        case 'entered':
        case 'entering':
          return menuEntering;
        case 'exited':
        case 'exiting':
          return menuExiting;
      }
    }}
    0.3s ease-out;
`;

export const CloseButton = styled(CrossSolid)`
  fill: black;
  position: absolute;
  right: 22px;
  top: 23px;
`;

export const Nav = styled('ul')``;

export const NavList = styled('li')`
  padding-top: 13px;
  padding-bottom: 13px;
  border-top: 1px solid ${(props) => props.theme.color.spaceGrayRGBA(0.1)};
  border-bottom: 1px solid ${(props) => props.theme.color.spaceGrayRGBA(0.1)};
  &:not(:first-child) {
    border-top: none;
  }
`;

const LinkStyle = css`
  ${(props) => props.theme.typography.base}
  color: ${(props) => props.theme.color.spaceGray};
  text-decoration: none;
`;

export const Link = styled('a')`
  ${LinkStyle}
`;

export const InternalLink = styled(RouterLink)`
  ${LinkStyle}
`;

export const CTA = styled(Button)`
  margin-top: ${(props) => props.theme.x2spacePx}px;
  margin-bottom: ${(props) => props.theme.x2spacePx}px;
`;
